import API from './index';
import AppUrls from '../config/AppUrls';
import { buildPathWithParams } from '../utils/Paths';
import { createAnchorDownloadFile } from '../utils/Functions';

class BatchCreationService {
  static fetchCashoutsBatch = async (filters) => {
    const response = await API.get(AppUrls.api.cashOutsBatch, filters);
    return response.data;
  };

  static cashoutCreateBatch = async (data) => {
    const response = await API.post(AppUrls.api.cashOutRequestBatch, data);
    return response.data;
  };

  static cashoutCreateFullBatch = async (data, countryIso) => {
    const response = await API.post(buildPathWithParams(AppUrls.api.cashOutRequestFullBatch, { countryIso }), data);
    return response.data;
  };

  static cashoutCreateBatchConfirm = async (idBatch) => {
    const response = await API.post(buildPathWithParams(AppUrls.api.cashOutRequestBatchConfirm, { idBatch }));
    return response.data;
  };

  static cashoutCreateFullBatchConfirm = async (idBatch) => {
    const response = await API.post(buildPathWithParams(AppUrls.api.cashOutRequestFullBatchConfirm, { idBatch }));
    return response.data;
  };

  static downloadCashoutBatch = async (idBatch) => {
    const response = await API.get(buildPathWithParams(AppUrls.api.cashOutsBatchDownload, { idBatch }));
    return response.data;
  };

  static downloadCashoutFullBatch = async (idBatch, fileName) => {
    const response = await API.get(buildPathWithParams(AppUrls.api.cashOutsFullBatchDownload, { idBatch }));
    createAnchorDownloadFile(response.data, fileName);
    return true;
  };

  static cancelCashoutBatch = async (idBatch) => {
    const response = await API.delete(buildPathWithParams(AppUrls.api.cashOutsBatchDownload, { idBatch }));
    return response.data;
  };

  static downloadFileExample = async (name, path) => {
    const response = await API.get(buildPathWithParams(AppUrls.api.cashOutsBatchDownloadFile, { name, path }));
    createAnchorDownloadFile(response.data, name);
  };
}

export default BatchCreationService;
